import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

/**
 * fetch selection list
 * @param {Object} filters selection list filter
 *  @param {Number} filters.page list pagination page number
 *  @param {Number} filters.size list pagination entry count
 *  @param {String} [filters.value] selection info text value for search
 *  @param {String} filters.type selection info list type
 */
const fetchSelectionsInfos = async function ({ page, size, value, type }) {
  try {
    const filter = {
      page, size, value, type
    }
    console.log('TCL: filter', filter)
    const res = await axios.get(urls.selectionInfoFilter + '?' + querystring.stringify(filter))
    console.log('TCL: res', res)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  fetchSelectionsInfos
}
